import React from 'react';
import styles from './BlogPreviewHeader.module.css';

import { Container, Grid, Column } from "../../components/Layout/Layout";
import { Button, IconCollection } from "../../components";

const BlogPreviewHeader = ({
  current,
  total,
  onNext,
  isLast,
}) => (
  <>
    <div className={styles.previewContainer}>
      <Container>
        <Grid columns={12}>
          <Column lg={8} md={7} sm={11}>
            <div >
              <h6 className={styles.listingpreviewTitle}>
                Blog Preview ({current} of {total})
              </h6>
              <p className={styles.reviewTitle}>
                This is a preview of how your blog post will appear to renters.
              </p>
            </div>
          </Column>
          <Column lg={4} md={5} sm={1} className={styles.previewButtonWrapper}>
            <div className={styles.previewSvg}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z" fill="#FDE4D7" />
                <path d="M12 6C15.5948 6 18.5854 8.58651 19.2124 12C18.5854 15.4135 15.5948 18 12 18C8.40525 18 5.4146 15.4135 4.7876 12C5.4146 8.58651 8.40525 6 12 6ZM12 16.6667C14.8238 16.6667 17.24 14.7013 17.8516 12C17.24 9.29869 14.8238 7.33333 12 7.33333C9.17624 7.33333 6.75998 9.29869 6.14836 12C6.75998 14.7013 9.17624 16.6667 12 16.6667ZM12 15C10.3432 15 9.00001 13.6569 9.00001 12C9.00001 10.3431 10.3432 9 12 9C13.6568 9 15 10.3431 15 12C15 13.6569 13.6568 15 12 15ZM12 13.6667C12.9205 13.6667 13.6667 12.9205 13.6667 12C13.6667 11.0795 12.9205 10.3333 12 10.3333C11.0796 10.3333 10.3333 11.0795 10.3333 12C10.3333 12.9205 11.0796 13.6667 12 13.6667Z" fill="#F2704E" />
              </svg>
              <p>
                Preview Mode
              </p>

            </div>

            <Button

              variant="info"
              className={`${styles.button} ${styles.buttonGhost}`}
              onClick={onNext}
              disabled={isLast}
              arrow="right"
              icon={<IconCollection name="arrow_righ_stright" />}
            >

              Next Blog 
            </Button>

          </Column>
        </Grid>
      </Container>
    </div>

    {/* <div className={styles.headerWrapper}>

    <Container>
      <div className={styles.headerContent}>
        <div className={styles.headerContentLeft}>
          <div className={styles.title}>Blog Preview ({current} of {total})</div>
          <div className={styles.subtitle}>This is a preview of how your blog post will appear to renters.</div>
        </div>
        <div className={styles.controls}>
          <span className={styles.previewMode}><span className={styles.eyeIcon}><i className="ri-eye-line"></i></span> Preview Mode</span>
          <button
            className={styles.nextBtn}
            onClick={onNext}
            disabled={isLast}
          >
            Next Blog <span className={styles.arrow}><i className="ri-arrow-right-line"></i></span>
          </button>
        </div>
      </div>
    </Container>

  </div> */}
  </>
);

export default BlogPreviewHeader;
